import { Navigate } from "react-router-dom";

import { Paths } from "../common/constants";
import { checkUserLoggedIn, getAccessToken } from "../common/utils";

const VerifyRoute = ({ children }: any) => {
  if (checkUserLoggedIn() && getAccessToken()) {
    return <Navigate to={Paths.MY_LIBRARY} />;
  } else if (!checkUserLoggedIn() && !getAccessToken())
    return <Navigate to={Paths.SIGNIN} />;
  else return children;
};

export default VerifyRoute;
